<template>
  <b-container fluid>
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>Filtros de Busca</strong>
        </h4>
        <a-form layout="vertical">
          <div class="row">
            <div class="col-xl">
              <a-form-item label="Serial">
                <a-input
                  placeholder="Serial"
                  v-model="filtrosLocal.serialNumber"
                />
              </a-form-item>
            </div>
            <div class="col-xl">
              <a-form-item label="Merchant:">
                <v-select
                  label="name"
                  :filterable="false"
                  :options="merchants"
                  :reduce="(merchant) => merchant.id"
                  v-model="filtrosLocal.idMerchant"
                  @search="onSearch"
                >
                  <template slot="no-options">Pesquisar Estabelecimento</template>
                  <template slot="option" slot-scope="option">{{
                    option.name
                  }}</template>
                  <template slot="selected-option" slot-scope="option">{{
                    option.name
                  }}</template>
                </v-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-xl">
              <a-form-item label="Status do Equipamento:">
                <a-select
                  default-value="0"
                  v-model="filtrosLocal.idDeviceStatus"
                >
                  <a-select-option value="0"> Selecione </a-select-option>
                  <a-select-option
                    :value="item.idDeviceStatus"
                    v-for="(item, index) in statusDispositivos"
                    :key="`statusDispositivo-${index}`"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-xl">
              <a-form-item label="Adquirente">
                <a-select default-value="0" v-model="filtrosLocal.idAcquirer">
                  <a-select-option value="0"> Selecione </a-select-option>
                  <a-select-option
                    :value="item.idAcquirer"
                    v-for="(item, index) in adquirentes"
                    :key="`adquirente-${index}`"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-xl" v-if="showCostCenter">
              <a-form-item label="Centro de Custo">
                <a-select default-value="0" v-model="filtrosLocal.idCostCenter">
                  <a-select-option value="0"> Selecione </a-select-option>
                  <a-select-option
                    :value="item.idCostCenter"
                    v-for="(item, index) in costCenters"
                    :key="`adquirente-${index}`"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
            </div>
            <div class="col-md-2">
              <b-button
                class="col-12"
                @click="filtrar"
                variant="outline-primary"
                >Filtrar</b-button
              >
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template v-else>

    <div class="row">

        <div class="col-xl">
            <div class="pt-3" :class="$style.container">
              <div class="bg-success" :class="$style.status"></div>
              <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                <div class="mr-auto">
                  <div
                    class="text-uppercase font-weight-bold font-size-24 text-dark"
                  >
                    {{ totals.avaiable  }}
                  </div>
                </div>
              </div>
              <div class="py-3 bg-gray-1 pl-4">Disponível</div>
            </div>
          </div>

          <div class="col-xl">
            <div class="pt-3" :class="$style.container">
              <div class="bg-success" :class="$style.status"></div>
              <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                <div class="mr-auto">
                  <div
                    class="text-uppercase font-weight-bold font-size-24 text-dark"
                  >
                    {{ totals.working }}
                  </div>
                </div>
              </div>
              <div class="py-3 bg-gray-1 pl-4">Habilitado</div>
            </div>
          </div>

          

            <div class="col-xl">
            <div class="pt-3" :class="$style.container">
              <div class="bg-success" :class="$style.status"></div>
              <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                <div class="mr-auto">
                  <div
                    class="text-uppercase font-weight-bold font-size-24 text-dark"
                  >
                    {{ totals.awaitingActivation  }}
                  </div>
                </div>
              </div>
              <div class="py-3 bg-gray-1 pl-4">Apto Habilitar</div>
            </div>
          </div>

          <div class="col-xl">
            <div class="pt-3" :class="$style.container">
              <div class="bg-danger" :class="$style.status"></div>
              <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                <div class="mr-auto">
                  <div
                    class="text-uppercase font-weight-bold font-size-24 text-dark"
                  >
                    {{ totals.broken  }}
                  </div>
                </div>
              </div>
              <div class="py-3 bg-gray-1 pl-4">Manutenção</div>
            </div>
          </div>
    </div>


      <a-button
        style="margin-bottom: 20px; margin-top:10px"
        type="primary"
        :disabled="selectedRowKeys.length == 0"
        :loading="loading"
        @click="editDevice"
      >
        Editar
      </a-button>
      <!-- Main table element -->
      <b-table
        show-empty
        stacked="md"
        selectable
        :items="displayItens"
        :fields="fields"
        :per-page="perPage"
        :filter="filter"
        @row-selected="onRowSelected"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:cell(selected)="{ rowSelected }">
          <!-- <b-checkbox :v-model="rowSelected"
                true-value="Sim"
                false-value="Não">
              @click
            </b-checkbox> -->
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template slot="name" slot-scope="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>

        <template slot="isActive" slot-scope="row">
          {{ row.value ? "Yes :)" : "No :(" }}
        </template>

        <!-- <template v-slot:cell(actions)="row">
          <b-button size="sm" :href="`/ativos/equipamentos/${row.item.idDevice}/edit`" class="mr-1">
            <i class="fe fe-edit"></i>
          </b-button>
        </template> -->

        <template slot="row-details" slot-scope="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>
    </template>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @input="onChangePage"
          class="my-0"
        ></b-pagination>
        total de
          {{ totalRows }}
      </b-col>
    </b-row>
    <b-modal ref="editar" hide-footer title="Editar equipamento" size="xl">
      <template v-slot:default="{ hide }">
        <formulario-equipamentos
          @hide="hide"
          :edicao="true"
          :dispositivo="dispositivoEditar"
        />
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import FormularioEquipamentos from "./formulario";
import { EquipamentosResource } from "@/resources/Equipamentos.resource.js";
import { MerchantResource } from "@/resources/Merchants.resource.js";
export default {
  name: "ListaEquipamentos",
  components: {
    FormularioEquipamentos,
  },
  data() {
    return {
      loading: false,
       totals : {
       broken: 0,
       avaiable :0,
       working:0,
       awaitingActivation : 0,
      
      },
      filtrosLocal: {
        index: 1,
        size: 25,
        serialNumber: 0,
        idDeviceStatus: 0,
        idAcquirer: 0,
        idMerchant: 0,
        idCostCenter: 0,
      },
      itens: [],
      costCenters: [],
      displayItens: [],
      selectedRowKeys: [],
      fields: [
        { key: "selected", label: "#" },
        { key: "serialNumber", label: "Serial" },
        { key: "logicNumber", label: "Numero Lógico	" },
        { key: "deviceStatusName", label: "Status" },
        { key: "deviceModelName", label: "Modelo" },
        { key: "deviceCategoryName", label: "Categoria" },
        { key: "merchantName", label: "Nome do estabelecimento" },
        { key: "costCenterName", label: "Centro de custo" },
        { key: "salesMan", label: "Representante" },
        { key: "actions", label: "Editar" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 75],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      statusDispositivos: [],
      merchants: [],
      adquirentes: [],
      dipositivoEditar: null,
    };
  },
  methods: {
    // status possiveis dos dispositivos
    getDeviceStatus() {
      EquipamentosResource.getStatus()
        .then((result) => {
          this.statusDispositivos = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },

    onRowSelected(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    getCostCenter() {
      this.$api
        .get("v1/CostCenter")
        .then((result) => {
          this.costCenters = result.data.payload.items;
        })
        .catch((e) => {
          // Surpress
        });
    },

    editDevice() {
      if (this.selectedRowKeys.length == 1) {
        this.$router.push({
          path: `/ativos/equipamentos/${this.selectedRowKeys[0].idDevice}/edit`,
        });
      } else {
        this.$router.push({
          name: "deviceGroup",
          params: { devices: this.selectedRowKeys },
        });
      }
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.merchants = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        })
        .catch((e) => {
          // Surpress
        });
    }, 350),
    // adquirentes
    getAcquirer() {
      this.$api
        .get("v1/Acquirer")
        .then((result) => {
          this.adquirentes = result.data.payload.items;
        })
        .catch((e) => {
          // Surpress
        });
    },
    // lista de todos os dispositivos cadastrados
    getListaDispositivos() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true;

        EquipamentosResource.getLista(this.filtrosLocal)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            // Surpress
            this.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },
    getDispositivo(idDevice) {
      if (typeof idDevice === "number") {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true;

        EquipamentosResource.getEquipamento({
          idDevice,
        })
          .then((result) => {
            try {
              if (result.data.isSuccess) {
                this.dipositivoEditar = result.data.payload;
              }
            } catch (e) {
              // TODO - TRATAR ERRO....
            }
            // try{
            //   this.itens[this.filtrosLocal.index] = result.data.payload.items;
            //   this.displayItens = this.itens[this.filtrosLocal.index].flat()
            //   this.totalRows = result.data.payload.pageSettings.total;
            //   this.loading = false
            // } catch(e) {
            //   throw {
            //     response: {
            //       data: {
            //         failureReason: 'Deu ruim na chamada...'
            //       }
            //     }
            //   }
            // }
          })
          .catch((e) => {
            // Surpress
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        // this.displayItens = this.itens[this.filtrosLocal.index].flat()
      }
    },
    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a;
      this.getListaDispositivos();
    },
    editarItem(item) {
      this.dispositivoEditar = item;
      this.$refs["editar"].show();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 25,
        serialNumber: 0,
        idDeviceStatus: 0,
        idAcquirer: 0,
        idCostCenter: 0,
      };
      this.filtrar();
    },

     getListaTotals()
    {
       
         EquipamentosResource.getStatusTotals(this.filtrosLocal)
          .then(result => {
          

           this.totals.avaiable = 0;
          this.totals.broken = 0;
          this.totals.awaitingActivation  = 0;
          this.totals.working = 0;

            try {
               
               const avaiableResult =  result.data.payload.filter( item => {
                 return item.idDeviceStatus === 1
                });

                if(avaiableResult.length > 0)
                {
                  this.totals.avaiable = avaiableResult[0].total
      
                }

                 const workingResult =  result.data.payload.filter( item => {
                 return item.idDeviceStatus === 2
                });

                if(workingResult.length > 0)
                {
                  this.totals.working = workingResult[0].total
      
                }

                const awaitingActivationResult =  result.data.payload.filter( item => {
                 return item.idDeviceStatus === 10
                });

                if(awaitingActivationResult.length > 0)
                {
                  this.totals.awaitingActivation = awaitingActivationResult[0].total
      
                }

                const brokenResult =  result.data.payload.filter( item => {
                 return item.idDeviceStatus === 4
                });

                if(brokenResult.length > 0)
                {
                  this.totals.broken = brokenResult[0].total
                }


            
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason:
                      "Erro ao solicitar os dados, por favor tente novamente"
                  }
                }
              };
            }
          })
          .catch(e => {
            // Surpress
            this.loading = false;
          });
      }, 
    
    filtrar() {
      // se algum item do filtro for 0, mudar para null
      this.filtrosLocal.idDeviceStatus =
        this.filtrosLocal.idDeviceStatus == 0
          ? null
          : this.filtrosLocal.idDeviceStatus;
      this.filtrosLocal.idAcquirer =
        this.filtrosLocal.idAcquirer == 0 ? null : this.filtrosLocal.idAcquirer;
      this.filtrosLocal.idCostCenter =
        this.filtrosLocal.idCostCenter == 0
          ? null
          : this.filtrosLocal.idCostCenter;
      this.filtrosLocal.serialNumber =
        this.filtrosLocal.serialNumber === 0
          ? null
          : this.filtrosLocal.serialNumber;
      this.filtrosLocal.idMerchant =
        this.filtrosLocal.idMerchant === 0
          ? null
          : this.filtrosLocal.idMerchant;
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getListaDispositivos();
      this.getListaTotals();

    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0);

        return result;
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
    this.getDeviceStatus();
    this.getAcquirer();
    this.getCostCenter();
  },
}; 
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
